import PromoService from '@/services/PromoService'

export default {
  actions: {
    async fetchPromoCollection (ctx) {
      const promoCollection = await PromoService.methods.getPromoCollection()
      ctx.commit('updatePromoCollection', promoCollection.GetPromocodesResponse.PromoCollection.PromoCollection)
    },
    async fetchRedeemPromoCode (ctx, promo) {
      const _promo = await PromoService.methods.redeemPromoCode({
        Amount: promo.amount,
        Code: promo.code,
        IssueNumber: promo.issue,
        RemittanceGateway: promo.remittanceGateway,
        ParentReferenceNumber: promo.parentReferenceNumber,
        ValidateOnly: promo.validateOnly
      })
      ctx.commit('updateRedeemPromoCode', _promo.RedeemPromoCodeResponse)
    }
  },
  mutations: {
    updatePromoCollection (state, promoCollection) {
      if (Array.isArray(promoCollection)) {
        state.promoCollection = promoCollection.map(promo => {
          (Object.values(promo).map((e, key) => {
            const objectKey = Object.keys(promo)[key].charAt(0).toLowerCase() + Object.keys(promo)[key].slice(1)
            promo[objectKey] = e._text
          }))
          return promo
        }).sort((a, b) => {
          if ((typeof localStorage.getItem('has-transactions') === 'boolean' && localStorage.getItem('has-transactions') && b.firstTransactionOnly === 'True') || (typeof localStorage.getItem('has-transactions') !== 'boolean' && b.firstTransactionOnly === 'True')) {
            return -1
          }
          return new Date(b.expirationDate) - new Date()
        })
      } else if (!!promoCollection && Object.keys(promoCollection).length > 0) {
        (Object.values(promoCollection).map((e, key) => {
          const objectKey = Object.keys(promoCollection)[key].charAt(0).toLowerCase() + Object.keys(promoCollection)[key].slice(1)
          promoCollection[objectKey] = e._text
        }))
        state.promoCollection = [promoCollection]
      } else if (!promoCollection) {
        state.promoCollection = []
      }
    },
    updateRedeemPromoCode (state, promo) {
      if (!!promo && Object.keys(promo).length > 0) {
        (Object.values(promo).map((e, key) => {
          const objectKey = Object.keys(promo)[key].charAt(0).toLowerCase() + Object.keys(promo)[key].slice(1)
          promo[objectKey] = e._text
        }))
        state.promo = promo
      }
    }
  },
  getters: {
    getPromoCollection (state) {
      return state.promoCollection
    },
    getPromo (state) {
      return state.promo
    }
  },
  state: {
    promoCollection: [],
    promo: null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/promo.js